import SideBar from "./Component/sidebar/sidebar";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Login from "./Component/login/login";
import Users from "./pages/Users/Users";
import Header from "./Component/header/Header";
import BotManagement from "./pages/botManagement/botManagement";
import Package from "./pages/Package/Package";
import Category from "./pages/category/category"
import { Toaster } from "react-hot-toast"
import Setting from "./pages/setting/setting";
import Poshtibani from "./pages/Poshtibani/Poshtibani";
import Gozareshat from "./pages/Gozareshat/Gozareshat";
import Crawler from "./pages/crawler/Crawler";


function App() {

    const accessToken = localStorage.getItem("accessToken");
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {

        if (!accessToken) {
            navigate('/')
        }

    }, [location.pathname]);

    return (
        <>
            <Toaster
                position="top-left"
                reverseOrder={false}
            />
            {accessToken ?
                <div className="grid grid-cols-10 md:grid-cols-8">

                    <div className="col-span-2 bg-gradient-to-b from-[#35577d] to-[#141e30] rounded-l-md md:hidden">
                        <SideBar />
                    </div>

                    <div className="col-span-8">

                        <Header />

                        <Routes>
                            <Route path={"/"} element={<Users />} />
                            <Route path={"/botManagement"} element={<BotManagement />} />
                            <Route path={"/packages"} element={<Package />} />
                            <Route path={"/category"} element={<Category />} />
                            <Route path={"/setting"} element={<Setting />} />
                            <Route path={"/poshtibani"} element={<Poshtibani />} />
                            <Route path={"/gozareshat"} element={<Gozareshat />} />
                            <Route path={"/crawler"} element={<Crawler />} />
                        </Routes>

                    </div>


                </div>
                :
                <Routes>
                    <Route path={"/"} element={<Login />} />
                </Routes>

            }
        </>
    );
}


export default App;
